import Category from "./components/Category";
import ItemCart from "./components/ItemCart";
import {GET_MARKET_ITEMS} from "../../helperData/ApiAddress";
import {useEffect, useState} from "react";
import {get} from "../../controlers/global/ConfigRequest";
import {Spinner} from "react-bootstrap";
import PaginationComponent from "../../component/global/PaginationComponent";
import {useTranslation} from "react-i18next";

export default function ItemsAll() {
  const [items, setItems] = useState(undefined);
  const [page, setPage] = useState("1");
  const [category, setCategory] = useState("");
  const {t} = useTranslation();
  useEffect(() => {
    var url = new URL(GET_MARKET_ITEMS);
    url.searchParams.set("page", page);
    url.searchParams.set("item_type_name", category);

    get(url).then((r) => {
      setItems(r);
    });
  }, [page, category]);

  const categoryHandle = (e) => {
    setCategory(e);
    setPage("1");
    setItems(undefined);
  };

  return (
    <div className="all-items-section items-section">
      <Category onClick={categoryHandle}/>
      <div className="cart-grid">
        {items ? (
          items.results.length > 0 ? (
            items.results.map((item, index) => (
              <ItemCart
                key={index}
                link={item.id}
                score={item.computed_score}
                description={item.description}
                name={item.name}
                photo={item.photo}
                priceMin={item.price_min}
                priceMax={item.price_max}
                salersCount={item.salers_count}
              />
            ))
          ) : (
            <span className="empty-item">
                {t("Organizational.SellingBasket.Not.Found.Title")}
            </span>
          )
        ) : (
          <Spinner animation="border"/>
        )}
      </div>
      {items?.count > 20 && (
        <PaginationComponent
          currentPage={page - 1}
          pageCount={Math.ceil(items.count / 20)}
          fetchData={(e) => setPage(e.pageIndex + 1)}
          feedbacks={items.results}
        />
      )}
    </div>
  );
}
